import { IResponse, IResponsePagination } from '@/types/common';
import {
  IGetListInquiryResponse,
  IInquiry,
  InquiryStatus,
} from '@/types/response/inquiry';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';
import { IGetListInquiryRequest } from '@/types/request/inquiry';

class Inquiry {
  getList = (
    params: IGetListInquiryRequest,
  ): Promise<IResponsePagination<IGetListInquiryResponse>> => {
    return axiosClient.get(ENDPOINT.INQUIRY.GET_LIST, { params });
  };

  getDetail = (id: number): Promise<IResponse<IInquiry>> => {
    return axiosClient.get(
      ENDPOINT.INQUIRY.GET_DETAIL.replace(':id', String(id)),
    );
  };

  updateStatus = ({
    id,
    status,
  }: {
    id: number;
    status: InquiryStatus;
  }): Promise<IResponse<IInquiry>> => {
    return axiosClient.patch(
      ENDPOINT.INQUIRY.UPDATE_STATUS.replace(':id', String(id)),
      {
        status,
      },
    );
  };
}

export const InquiryService = new Inquiry();
